import { TOOLBARS } from 'wix-rich-content-editor-common';
import addOfficialEmote from '../modifiers/add-official-emote';
import addCommunityEmote from '../modifiers/add-community-emote';
import { DA_EMOTE_TYPE } from '../types';
import EmoteIcon from '../../../../Icons/24x24/AddEmoticon';
export default function createToolbar(_a) {
    var helpers = _a.helpers, t = _a.t, settings = _a.settings, getEditorState = _a.getEditorState, setEditorState = _a.setEditorState;
    return {
        InsertButtons: createInsertButtons({
            helpers: helpers,
            t: t,
            settings: settings,
            getEditorState: getEditorState,
            setEditorState: setEditorState,
        }),
    };
}
var createInsertButtons = function (_a) {
    var helpers = _a.helpers, t = _a.t, settings = _a.settings, getEditorState = _a.getEditorState, setEditorState = _a.setEditorState;
    return [
        {
            type: 'modal',
            name: 'Emote',
            tooltip: t('editorToolbar.tooltips.addEmote'),
            getIcon: function () { return EmoteIcon; },
            componentData: (settings === null || settings === void 0 ? void 0 : settings.componentDataDefaults) || {},
            toolbars: [TOOLBARS.FOOTER, TOOLBARS.SIDE, TOOLBARS.INSERT_PLUGIN],
            helpers: helpers,
            modalName: DA_EMOTE_TYPE,
            // ssh hack the modal props with our callback ;)
            modalElement: function (data) {
                if (data.type === 'official') {
                    var updatedState = addOfficialEmote(getEditorState(), data.title);
                    setEditorState(updatedState);
                }
                if (data.type === 'community' || data.type === 'user') {
                    var updatedState = addCommunityEmote(getEditorState(), data);
                    setEditorState(updatedState);
                }
            },
        },
    ];
};
//# sourceMappingURL=index.js.map